/* eslint-disable */
import React, { Component, createRef } from "react";
import cookie from "react-cookies";
import axios from "axios";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import validator from "validator";
import moment from "moment";
import { format } from "date-fns";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import { template } from "underscore";
var todayDate = new Date();
class Templateform extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editID: this.props.params?.templateID || "",
      pageloading: false,
      btndisabled: false,
      whatsapptemplatedata: {
        template_name: "",
        template_content_type: [],
        template_body_content: "",
        template_media_image: "",
        template_footer_text: "",
        template_button_text: "",
        template_website_URL: "",
        template_varbl_count: 1,
        template_varbls: [],
        template_error_text: "",
        template_name_als: "",
        template_twilio_sid: "",
        template_createdAt: "",
        template_twilio_status: "",
        template_whatsapp_status: "",
        template_category: "",
        action: "add",
      },
      loading: true,
      checked: true,
      formpost: [],
      templateDetail: [],
      contenttypeList: [{
        label: 'Text',
        value: 'Text',
      },{
        label: 'Media',
        value: 'Media',
      },{
        label: 'Card',
        value: 'Card',
      }]
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {

    if (this.state.editID !== "") {
      var params = {
        url: `${apiUrl}whatsapptemplate/details/${this.state.editID}`,
        type: "master",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success");
          this.props.navigate("/clientpanel/whatsapptemplate");
        } else {
          showAlert("Error", errMsg, "error");
        }
      }
    }

    if (
          this.state.templateDetail !== nextProps.detaildata &&
          this.state.editID !== ""
        ) {
          this.setState({ templateDetail: nextProps.detaildata }, function () {
            if (nextProps.detaildata[0].status === "ok") {
              var result = nextProps.detaildata[0].result;
              let contentType = {
                label: result.template_content_type,
                value: result.template_content_type,
              };

              var templatevarblcount = (result.template_varbl_count != "") ? parseInt(result.template_varbl_count) : result.template_varbl_count;
              var templatevarbls = (result.template_varbls != "") ? JSON.parse(result.template_varbls) : [];
              
              var whatsapptemplatedata = {
                template_name: result.template_name,
                template_content_type: contentType,
                template_body_content: result.template_body_content,
                template_media_image: result.template_media_image,
                template_footer_text: result.template_footer_text,
                template_button_text: result.template_button_text,
                template_website_URL: result.template_website_URL,
                template_varbl_count: templatevarblcount,
                template_varbls: templatevarbls,
                template_error_text: "",
                template_name_als: result.template_name_als,
                template_twilio_sid: result.template_twilio_sid,
                template_createdAt: (result.createdAt != "" && result.createdAt != undefined) ? moment(new Date(result.createdAt)).format("yyyy-MM-dd") : "",
                template_twilio_status: result.template_twilio_status,
                template_whatsapp_status: result.template_whatsapp_status,
                template_category: result.template_category,
                action: "edit",
              };
              this.setState({ whatsapptemplatedata: whatsapptemplatedata, pageloading: false });
            } else {
              showAlert("Error", "Invalid Company", "error");
            }
          });
        }
    
  }

  sateValChange = (field, value) => {
    if (field === "page") {
    } else {
      this.setState({ btndisabled: value });
    }
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    let tempval = '';
    this.setState(
      update(this.state, { whatsapptemplatedata: { [field]: { $set: value }, ['template_error_text']: { $set: tempval } } }), () => {
        if(field == 'template_varbl_count') {
          var indxVal = (value != '' && parseInt(value) > 1) ? parseInt(value) - 1 : 1;
          var indKey = "Index_" + indxVal;
          var varblFieldArr = {varbl_indx:indxVal,varbl_value:""};
          var templateVarblsArr = this.state.whatsapptemplatedata.template_varbls;
              //templateVarblsArr[indKey] = varblFieldArr;
              templateVarblsArr.push(varblFieldArr);
              this.setState(
                update(this.state, { whatsapptemplatedata: { ['template_varbls']: { $set: templateVarblsArr } } })
              );   
        } else if(field == 'template_content_type') {
            
          let whatsapptemplatedataObj = this.state.whatsapptemplatedata;
          whatsapptemplatedataObj.template_body_content = "";
          whatsapptemplatedataObj.template_media_image = "";
          whatsapptemplatedataObj.template_footer_text = "";
          whatsapptemplatedataObj.template_button_text = "";
          whatsapptemplatedataObj.template_website_URL = "";
          whatsapptemplatedataObj.template_varbl_count = 1;
          whatsapptemplatedataObj.template_varbls = [];
          this.setState({ whatsapptemplatedata: whatsapptemplatedataObj });

        }
      }
    );
    
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var templatedata = this.state.whatsapptemplatedata;
    let errorMsgTxt = '';
    let templateBodyContent = templatedata.template_body_content;
    templateBodyContent = (templateBodyContent != '') ? templateBodyContent.trim() : "";
    let templateContentType = templatedata.template_content_type?.value || '';
    if(Object.keys(templatedata.template_content_type).length == 0) {
        errorMsgTxt = 'Please select the content type.';
    } else if(templateBodyContent == '') {
        errorMsgTxt = 'Please enter the body content.';
    } else if(templateContentType == 'Media' && templatedata.template_media_image == '') {
        errorMsgTxt = 'Please upload the image.';
    }
console.log('templatedatatemplate_varbls', templatedata.template_varbls);
    if(errorMsgTxt == '') {

      var posData = {
        template_created_byadmin:"Yes",
        template_name:templatedata.template_name.trim(),
        template_content_type:templatedata.template_content_type?.value || '',
        template_body_content:templatedata.template_body_content,
        template_media_image:templatedata.template_media_image,
        template_footer_text:templatedata.template_footer_text,
        template_button_text:templatedata.template_button_text,
        template_website_URL:templatedata.template_website_URL,
        template_varbl_count:templatedata.template_varbl_count,
        template_varbls:JSON.stringify(templatedata.template_varbls),
      }
      var post_url = "whatsapptemplate";
      let method = "post";
      this.props.getFormPost(posData, post_url, "master", method);

    } else {
      templatedata.template_error_text = errorMsgTxt;
      this.setState({ whatsapptemplatedata: templatedata });
      hideLoader("submit_frm", "class");
    }
    
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"whatsapptemplate"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "View" : "Add New"} Whatsapp Template
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <Link to={"/clientpanel/whatsapptemplate"}>
                      <button
                        type="button"
                        className="btn btn-outline-primary waves-effect"
                      >
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
                <Form
                  {...this.props}
                  fields={this.state.whatsapptemplatedata}
                  btndisabled={this.state.btndisabled}
                  sateValChange={this.sateValChange}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  contenttypeList={this.state.contenttypeList}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>

              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>

        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Templateform);

const isEmpty = (value) => (value === "" ? "This field is required." : null);

function validationConfig(props) {
  const {
    template_name,
  } = props.fields;
  if (props.fields.action === "add") {
    return {
      fields: [
        "template_name",
      ],

      validations: {
        template_name: [[isEmpty, template_name]],
      },
    };
  } else {
    return {
      fields: [
        "template_name",
      ],

      validations: {
        template_name: [[isEmpty, template_name]],
      },
    };
  }
}

class Form extends Component {
  constructor(props) {
    super(props);

    this.textareaRef = createRef();
  }

  insertVaribleFun = () => {
    const textarea = this.textareaRef.current;
    if (!textarea) return;

    let varblCount = this.props.fields.template_varbl_count;
    const numberToInsert = '{{'+varblCount+'}}';
    const startPos = textarea.selectionStart;
    const endPos = textarea.selectionEnd;

    let varblCountNew = varblCount + 1;

    // Insert number at cursor position
    const newText =
      this.props.fields.template_body_content.substring(0, startPos) +
      numberToInsert +
      this.props.fields.template_body_content.substring(endPos);

      this.props.onChange('template_body_content', newText);

      let $_thisvar = this;
      setTimeout(() => {
        textarea.selectionStart = textarea.selectionEnd =
          startPos + numberToInsert.toString().length;
        textarea.focus(); // Keep focus on textarea
        $_thisvar.props.onChange('template_varbl_count', varblCountNew);
      }, 0);

      /*this.setState({ text: newText }, () => {
          textarea.selectionStart = textarea.selectionEnd =
            startPos + numberToInsert.toString().length;
          textarea.focus();
        });*/
  };

  handleChange(name, value) {
    this.props.onChange(name, value);
  }

  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  handleVarblChange(varblArr, varblIndx, inptValue) {
      let varblFieldArr = varblArr;
      varblFieldArr['varbl_value'] = inptValue.target.value;
      var templateVarblsArr = this.props.fields.template_varbls;
      templateVarblsArr[varblIndx] = varblFieldArr;
      this.props.onChange('template_varbls', templateVarblsArr);
  }

  async uplaodFiles(imageType) {
    this.props.sateValChange("btndisabled", true);
    /*showLoader("ImageDetails");*/
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "whatsapptemplate", "client", 'epicpay');
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader("ImageContainer");
    /*hideLoader("ImageDetails");*/
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }

  showImageName(fields) {
    let imageUrlTxt = fields.template_media_image;
    let imageNameTxt = imageUrlTxt.replace("https://goepicpay.s3.amazonaws.com/whatsapptemplate/", "");
    return imageNameTxt;
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgName = "";
    if ($validation.template_name.error.reason !== undefined) {
      errMsgName = $validation.template_name.show && (
        <span className="error">{$validation.template_name.error.reason}</span>
      );
    }

    console.log('template_varbls', fields.template_varbls);
    return (
      <form className="card-body fv-plugins-bootstrap5" id="modulefrm">
        <div
          className="accordion mt-3 accordion-header-primary"
          id="accordionStyle1"
        >
          <div className="accordion-item active">
            <br></br>
            <div
              id="accordionStyle1-3"
              className="accordion-collapse collapse show"
              data-bs-parent="#accordionStyle1"
            >
              <div className="accordion-body">
                {(fields.template_error_text != "") && <p className="template-error-cls">{fields.template_error_text}</p>}
                <div className="row g-3">

                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="template_name"
                        disabled={true}
                        value={fields.template_name}
                      />
                      <label htmlFor="template_name">
                      Template Name <span className="error">*</span>
                      </label>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="template_name_als"
                        disabled={true}
                        value={fields.template_name_als}
                      />
                      <label htmlFor="template_name_als">
                        Template alis name
                      </label>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="template_twilio_sid"
                        disabled={true}
                        value={fields.template_twilio_sid}
                      />
                      <label htmlFor="template_twilio_sid">
                      Content template SID 
                      </label>
                    </div>
                  </div>
                 
                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="template_content_type"
                        disabled={true}
                        value={fields.template_content_type.value}
                      />
                      <label htmlFor="template_content_type">
                      Content Type 
                      </label>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="template_whatsapp_status"
                        disabled={true}
                        value={(fields.template_whatsapp_status == 'received')?"initiated":fields.template_whatsapp_status}
                      />
                      <label htmlFor="template_whatsapp_status">
                        WhatsApp approval status
                      </label>
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="template_category"
                        disabled={true}
                        value={fields.template_category}
                      />
                      <label htmlFor="template_category">
                      WhatsApp Category
                      </label>
                    </div>
                  </div>

                </div>

                {(Object.keys(fields.template_content_type).length > 0) && <div className="row g-3">
                    <div className="col-md-6">
                      <div className="content-mk-header">
                        <h5>Configure content - {fields.template_content_type.value}</h5>
                      </div>
                      <div className="content-mk-body">

                      <div className="col-md-12 template_body_div">
                          <div className="template_lable">Body Content</div>
                          <textarea
                            ref={this.textareaRef}
                            rows="6"
                            id="template_body"
                            className="template_body"
                            value={fields.template_body_content}
                            {...$field("template_body_content", (e) =>
                              onChange("template_body_content", e.target.value)
                            )}
                            placeholder=""
                          />
                      </div>

                      {(Object.keys(fields.template_varbls).length > 0) && <div className="col-md-12 template_varbl_div">
                          <br></br>
                          <div className="template_varbllable">Sample content for variable</div>
                          <div className="row template_varbl_innerdiv">
                          
                          {(fields.template_varbls || []).map((templateVarbls, index) => {
                              let indexVal = index + 1;
                              return (
                                <div className="col-md-4" key={index}>
                                  <div className="form-floating form-floating-outline mb-4">
                                    <input type="text" className="form-control" maxlength="20" name="template_variable_text" value={templateVarbls.varbl_value} onChange={this.handleVarblChange.bind(
                                        this,
                                        templateVarbls,
                                        index
                                    )} />
                                    <label htmlFor="template_variable_text">
                                      Variable {"{{"+indexVal+"}}"}
                                    </label>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                
                      </div>}

                      {(fields.template_content_type.value == 'Media' || fields.template_content_type.value == 'Card') && <div className="col-md-12">
                      <br></br>
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainer">
                          <label htmlFor="formFile" className="form-label">
                              Media(Image)
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="template_media_image"
                            onChange={(event) => {
                              this.uplaodFiles("template_media_image", event);
                              return false;
                            }}
                          />
                          {/*For Recommendation Size : <b>200px X 200px</b><br/>*/}
                          {/*(fields.template_media_image != "") && <div className="imageUrlTxt">{fields.template_media_image}</div>*/}
                          {(fields.template_media_image != "") && <div className="imageUrlTxt">{this.showImageName(fields)}</div>}
                        </div>
                        
                        </div>
                      </div>}


                      {(fields.template_content_type.value == 'Card') && <>
                      <div className="col-md-12">
                        <div className="form-floating form-floating-outline mb-4">
                          <input
                            type="text"
                            className="form-control"
                            name="template_footer_text"
                            value={fields.template_footer_text}
                            {...$field("template_footer_text", (e) =>
                              onChange("template_footer_text", e.target.value)
                            )}
                          />
                          <label htmlFor="template_footer_text">
                            Footer
                          </label>
                        </div>
                      </div>

                        <div className="col-md-12 template_button_div">
                          <div className="template_button_lable">Button</div>
                          <div className="template_button_inner">

                            <div className="col-md-12">
                              <div className="form-floating form-floating-outline mb-4">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="template_button_text"
                                  value={fields.template_button_text}
                                  {...$field("template_button_text", (e) =>
                                    onChange("template_button_text", e.target.value)
                                  )}
                                />
                                <label htmlFor="template_button_text">
                                  Button Text
                                </label>
                              </div>
                            </div>

                            <div className="col-md-12">
                              <div className="form-floating form-floating-outline mb-4">
                                <input
                                  type="text"
                                  className="form-control"
                                  name="template_website_URL"
                                  value={fields.template_website_URL}
                                  {...$field("template_website_URL", (e) =>
                                    onChange("template_website_URL", e.target.value)
                                  )}
                                />
                                <label htmlFor="template_website_URL">
                                  Website URL
                                </label>
                              </div>
                            </div>


                          </div>
                        </div>

                        </>}
                      

                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="content-preview-header">
                        <h5>Message preview</h5>
                      </div>
                      <div className="content-preview-body">

                          <div className="whatsapptmpl-phone">
                              <div className="whatsapptmpl-top-bar">
                                  <div className="whatsapptmpl-icon"></div>
                                  <div className="whatsapptmpl-phone-number">Your phone number</div>
                              </div>
                              <div className="whatsapptmpl-screen">
                                  <div className="whatsapptmpl-screen-inner">
                                    {(Object.keys(fields.template_content_type).length > 0 && fields.template_content_type.value == 'Card') && <div className="whatsapptmpl-media-image">
                                        <img className="whatsapptmpl-mediaimage" alt="" src={fields.template_media_image} />
                                    </div>}

                                    <div className="whatsapptmpl-body"><pre>{fields.template_body_content}</pre></div>
                                    
                                    {(Object.keys(fields.template_content_type).length > 0 && fields.template_content_type.value == 'Media') && <div className="whatsapptmpl-media-image">
                                        <img className="whatsapptmpl-mediaimage" alt="" src={fields.template_media_image} />
                                    </div>}

                                    {(Object.keys(fields.template_content_type).length > 0 && fields.template_content_type.value == 'Card') && <>
                                    <div className="whatsapptmpl-footer">{fields.template_footer_text}</div>

                                    {(fields.template_button_text != '' && fields.template_website_URL != '') && <a href={fields.template_website_URL} target="_blank" className="template_website_button">
                                        <i className="fa fa-external-link" aria-hidden="true"></i>
                                        {fields.template_button_text}
                                    </a>}
                                    </>}
                                  </div>
                              </div>
                          </div>

                      </div>
                    </div>
                </div>}

              </div>
            </div>
          </div>

        </div>
        
      </form>
    );
  }
}
Form = validated(validationConfig)(Form);
